import React, { useState } from "react";
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";
import CenterStageSection from "./CenterStageSection";
import TimelineSection from "./TimelineSection";
import ProfileComponent from "./ProfileComponent";

const ChurchAdminChild = () => {
  const [{ errorLogApi, placeHolderText, Category, user }] = useAtom(gbState);
  const [logggedUser, setLoggedUser] = useState(user);
  //console.log(user);
  return (
    <div className="flex flex-grow bg-gray-100">
      <div className="flex flex-grow bg-gray-100">
        <div className="hidden w-1/5 md:block">
          <div className="sticky top-0 h-screen overflow-y-auto overflow-y-hidden">
            <ProfileComponent member={user} />
          </div>
        </div>
        <div className="w-full md:hidden">
          <TimelineSection />
        </div>
        <div className="hidden md:flex md:w-4/5">
          <div className="flex w-full overflow-y-auto">
            <CenterStageSection />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChurchAdminChild;
